import { getCaseAverageLodgmentSurface } from './getCaseAverageLodgmentSurface';
import { getCaseTotalSurfaceWeighting } from './getCaseTotalSurfaceWeighting';
import { CaseProjection } from '../../CaseProjection';

export const getCaseEligibleLodgmentAverageTotalCount = (caseProjection: CaseProjection) =>
  caseProjection.projectedSurfaceForSale.value /
  (getCaseAverageLodgmentSurface(caseProjection) + getCaseTotalSurfaceWeighting(caseProjection));
